import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './RadioButton.module.scss';

const RadioButton = ({ className, children, fluid = true, onChange, value, style, type = 'normal', size = 'normal' }) => {
  const options = Children.map(children, child => cloneElement(child, {
    onChange,
    fluid,
    type,
    size,
    active: child.props.value === value,
    key: child.props.value,
  }));

  const mainClass = classNames({
    [styles.main]: true,
    [styles[`main--${size}`]]: !!size,
    [className]: !!className,
  });

  return (
    <div className={mainClass} style={style}>
      {options}
    </div>
  );
};

RadioButton.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
  style: PropTypes.instanceOf(Object),
  type: PropTypes.oneOf(['normal', 'filled']),
  size: PropTypes.oneOf(['large', 'normal', 'compact']),
  fluid: PropTypes.bool,
  className: PropTypes.string,
};

export default RadioButton;
